import * as Yup from "yup";

const TeamGroupTeamSchema = () => Yup.object().shape({
  team_ids: Yup
    .array()
    .label("Teams")
});

export default TeamGroupTeamSchema;
